import React, {useState} from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import UserTab from './UserTab';
import styles from '../styles/header/Navbar.module.scss';
import {accountMenuList } from './mainMenuList';
import NavbarLinks from './NavbarLinks';
import CookieConsent from '../cookie/CookieConsent';
import MobileMenu from './MobileMenu';
import CartTab from './cart/CartTab';

const ShopNavbar = (props) => {

    const {menu, selected, cart} = props;
    const [isOpen, editIsOpen] = useState(false);
    const toggleMobileMenu = () => {
        if (!isOpen) {
            document.querySelector("body").classList.add('mobile-menu');
        } else {
            document.querySelector("body").classList.remove('mobile-menu');
        }
        editIsOpen(!isOpen);
    }
    const closeMenu = () => {
        editIsOpen(false); document.querySelector("body").classList.remove('mobile-menu');
    }

    return (
        <>
            <CookieConsent />
            <Navbar className="main-nav"  expand="lg">
                <Link href={process.env.NEXT_PUBLIC_WEB}>
                    <Navbar.Brand target="_blank" className={`ms-lg-3 me-auto d-flex align-items-center ${styles.logo}`} >
                        <Image src="/images/icons/conso.png" width={111} height={33}  alt="Conso" />  
                    </Navbar.Brand>
                </Link>
                
                <Navbar.Toggle 
                    aria-controls="basic-navbar-nav" 
                    className="order-2" 
                    onClick={toggleMobileMenu} 
                /> 
                <CartTab cart={cart} />
                <UserTab />
                
            </Navbar>
            {isOpen && 
            <MobileMenu 
                menuList={menu}
                closeMenu={closeMenu}
            />}
        </>
    );
}

export default ShopNavbar;